import * as yup from 'yup';

export const validateCompanyName = yup
  .string()
  .trim()
  .min(4, 'Företagsnamnet måste innehålla minst fyra bokstäver')
  .max(500, 'Företagsnamnet får inte överstiga 500 tecken')
  .test(
    // https://bolagsverket.se/en/bus/business/limited/2.1147/business-name
    'Name conforms to the Swedish government rules for company names',
    'Företagsnamnet på ett aktiebolag måste innehålla ordet "Aktiebolag" eller förkortningarna "AB", "Ab", "ab"',
    (value) => {
      if (!value) return false;

      const parts = value.split(' ');
      // TODO: Write tests for validation
      const match = /^(AB|Aktiebolag|ab|Ab|aktiebolag)$/;

      for (const part of parts) {
        if (match.test(part)) {
          return true;
        }
      }

      return false;
    },
  );
